import { render, staticRenderFns } from "./bottomRight.vue?vue&type=template&id=6433c69c&scoped=true&"
import script from "./bottomRight.vue?vue&type=script&lang=js&"
export * from "./bottomRight.vue?vue&type=script&lang=js&"
import style0 from "./bottomRight.vue?vue&type=style&index=0&id=6433c69c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6433c69c",
  null
  
)

export default component.exports